module.exports = __webpack_public_path__ + "images/122_1024.jpg";